import postcss from 'postcss';
import {logicalDeclaration} from './logicalSkin';
import type {BehaviorProposal} from './templateBehaviors';
/** Evidence from the snapshot stylesheet, kept as proposals until the Maker removes the shell. */
export function shellLayouts(doc:Document,paths:Map<Element,(string|number)[]>,css:string,proposals:BehaviorProposal[]):void{
 const sheet=postcss.parse(css);
 const styles=new WeakMap<Element,Record<string,string>>();
 const declarations=(el:Element):Record<string,string>=>{
  const cached=styles.get(el);
  if(cached)return cached;
  const result:Record<string,string>={};
  sheet.walkRules(rule=>{if(rule.parent?.type!=='root')return;try{if(el.matches(rule.selector))rule.walkDecls(d=>{result[d.prop]=d.value;});}catch{/* Unsupported selectors are not layout evidence. */}});
  const inline=(el as HTMLElement).style;if(inline)for(const key of Array.from(inline))result[key]=inline.getPropertyValue(key);
  styles.set(el,result);
  return result;
 };
 for(const proposal of proposals){
  if(!proposal.shellPath)continue;
  const shell=[...paths].find(([,path])=>JSON.stringify(path)===JSON.stringify(proposal.shellPath))?.[0];
  if(!shell?.parentElement)continue;
  const parent=shell.parentElement,layout:NonNullable<BehaviorProposal['layout']>=[];
  const parentStyle=declarations(parent),shellStyle=declarations(shell);
  const patch=(el:Element,style:Record<string,string>)=>{const path=el===doc.body?[]:paths.get(el);if(path&&Object.keys(style).length)layout.push({path,style});};
  // A fixed first track reserved for a removed sidebar becomes the content track.
  const columns=parentStyle['grid-template-columns']??'';
  if(parentStyle.display==='grid'&&/^\s*\d+(?:\.\d+)?(?:px|rem|em)\s+(?:1fr|minmax\(0,\s*1fr\))\s*$/.test(columns)&&parent.children[0]===shell){
   patch(parent,{'grid-template-columns':'minmax(0, 1fr)'});
   for(const sibling of Array.from(parent.children).filter(el=>el!==shell))patch(sibling,{'grid-column':'1','min-width':'0'});
  }
  const width=shellStyle.width??shellStyle['inline-size'];
  if(width&&/^\d+(?:\.\d+)?(?:px|rem|em)$/.test(width)&&['fixed','absolute'].includes(shellStyle.position)){
   for(const sibling of Array.from(parent.children).filter(el=>el!==shell)){
    const style=declarations(sibling),reset:Record<string,string>={};
    for(const prop of ['margin-left','padding-left','margin-inline-start','padding-inline-start'])if(style[prop]===width)reset[logicalDeclaration(prop,width).property]='0';
    if(Object.keys(reset).length){reset.width='auto';reset['min-width']='0';patch(sibling,reset);}
   }
  }
  proposal.layout=layout;
 }
}
